export default __webpack_public_path__ + "static/media/img43.70ecfc89.jpg";